<div class="flex-container" data-cy="recall-container">
  <div fxFlex="25" fxLayout="column" class="flex-column left" data-cy="recall-left-column">
    <div fxFlex="33" fxLayout="row" class="leftDiv" data-cy="recall-final-report-section">
      <div fxLayout="column" fxFlex="100" style="overflow: auto; max-height: 33vh" data-cy="recall-final-report-container">
        <div fxLayout="row">
          <mat-label class="leftLabel" data-cy="recall-final-report-label">Final Report: </mat-label>
        </div>

        <div fxLayout="row" style="font-size: 14px" data-cy="recall-date-completed-row">
          <div fxFlex="40" fxLayout="column" class="flex-column" style="align-items: end; display: flex; margin-right: 5px" data-cy="recall-date-completed-label">
            Date Completed:
          </div>
          <div fxFlex="60" fxLayout="column" class="flex-column" style="align-items: start; display: flex; " *ngIf="finalReport && finalReport.CompletedDate !== null" data-cy="recall-date-completed-value">
            {{finalReport.CompletedDate | date: 'MM-dd-YY'}}
          </div>
          <div fxFlex="60" fxLayout="column" class="flex-column" style="align-items: start; display: flex; " *ngIf="!finalReport || finalReport.CompletedDate === null" data-cy="recall-date-completed-no-data">
            No Data
          </div>
        </div>

        <div fxLayout="row" style="font-size: 14px" data-cy="recall-pulp-diagnosis-row">
          <div fxFlex="40" fxLayout="column" class="flex-column" style="align-items: end; display: flex;  margin-right: 5px" data-cy="recall-pulp-diagnosis-label">
            Pulp Diagnosis:
          </div>
          <div fxFlex="60" fxLayout="column" class="flex-column" style="align-items: start; display: flex; "*ngIf="finalReport && finalReport.isDiagnosticsLarge" data-cy="recall-pulp-diagnosis-value">
            {{finalReport.isDiagnosticsLarge}}
          </div>
          <div fxFlex="60" fxLayout="column" class="flex-column" style="align-items: start; display: flex; " *ngIf="!finalReport" data-cy="recall-pulp-diagnosis-no-data">
            No Data
          </div>
        </div>

        <div fxLayout="row" style="font-size: 14px" data-cy="recall-perlap-diagnosis-row">
          <div fxFlex="40" fxLayout="column" class="flex-column" style="align-items: end; display: flex; margin-right: 5px" data-cy="recall-perlap-diagnosis-label">
            Perlap Diagnosis:
          </div>
          <div fxFlex="60" fxLayout="column" class="flex-column" style="align-items: start; display: flex; "*ngIf="finalReport && finalReport.isDiagnosticsLarge" data-cy="recall-perlap-diagnosis-value">
            {{finalReport.isSendDiagnostics}}
          </div>
          <div fxFlex="60" fxLayout="column" class="flex-column" style="align-items: start; display: flex; " *ngIf="!finalReport" data-cy="recall-perlap-diagnosis-no-data">
            No Data
          </div>
        </div>

        <div fxLayout="row" style="font-size: 14px" data-cy="recall-second-treatment-row">
          <div fxFlex="40" fxLayout="column" class="flex-column" style="align-items: end; display: flex; margin-right: 5px" data-cy="recall-second-treatment-label">
            2nd Rec'd Trmt:
          </div>
          <div fxFlex="60" fxLayout="column" class="flex-column" style="align-items: start; display: flex;" *ngIf="finalReport && finalReport.enumCaseTypeID !==null" data-cy="recall-second-treatment-value">
            <span *ngFor="let val of caseTypeEnums | enumDisplay: finalReport.enumCaseTypeID" data-cy="recall-second-treatment-item">{{val.ItemDisplayValue}}</span>
          </div>
          <div fxFlex="60" fxLayout="column" class="flex-column" style="align-items: start; display: flex; " *ngIf="!finalReport || finalReport.enumCaseTypeID === null" data-cy="recall-second-treatment-no-data">
            No Data
          </div>
        </div>

        <div fxLayout="row" style="font-size: 14px">
          <div fxFlex="40" fxLayout="column" class="flex-column" style="align-items: end; display: flex; margin-right: 5px ">
            Prognosis:
          </div>
          <div fxFlex="60" fxLayout="column" class="flex-column" style="align-items: start; display: flex; "*ngIf="finalReport && finalReport.enumFinalReportPrognosisID !==null">
            <span  *ngFor="let val of prognosisEnums | enumDisplay: finalReport.enumFinalReportPrognosisID">{{val.ItemDisplayValue}}</span>
          </div>
          <div fxFlex="60" fxLayout="column" class="flex-column" style="align-items: start; display: flex; "
               *ngIf="!finalReport || finalReport.enumFinalReportPrognosisID === null">
            No Data
          </div>
        </div>

        <div fxLayout="row" style="font-size: 14px">
          <div fxFlex="40" fxLayout="column" class="flex-column" style="align-items: end; display: flex; margin-right: 5px ">
            Rest Recomm:
          </div>
          <div fxFlex="60" fxLayout="column" class="flex-column" style="align-items: start; display: flex; " *ngIf="finalReport && finalReport.dataPatientCaseEndoFinalReportRestorRecomds !== null">
            <div fxLayout="row" *ngFor="let recom of finalReport.dataPatientCaseEndoFinalReportRestorRecomds, let d = index">
              <span  *ngFor="let val of restorationMethodEnums | enumDisplay: recom.enumFinalReportRestorationMethodID">{{d + 1}}. {{val.ItemDisplayValue}}</span>
            </div>
            <div fxLayout="row" *ngIf="!finalReport || finalReport.dataPatientCaseEndoFinalReportRestorRecomds === null">
              No data
            </div>
          </div>
          <div fxFlex="60" fxLayout="column" class="flex-column" style="align-items: start; display: flex; " *ngIf="!finalReport || finalReport.dataPatientCaseEndoFinalReportRestorRecomds === null">
            No data
          </div>
        </div>

        <div fxLayout="row" class="flex-column" style="text-align: left; align-items: start; margin-left: 5px" *ngIf="!finalReport">
          No Data
        </div>

      </div>
    </div>

    <div fxFlex="35" fxLayout="row" class="leftDiv" style="padding-bottom: 2%" data-cy="recall-treatment-section">
      <div fxLayout="column" fxFlex="100" data-cy="recall-treatment-container">

        <mat-label class="leftLabel" data-cy="recall-treatment-label">Treatment: </mat-label>
        <div  fxFlex="30" fxLayout="row" style="margin-top: 3%">

          <div fxFlex="25" fxLayout="column" class="flex-column" style="align-items: end; display: flex; ">
            <div fxLayout="row" class="label" data-cy="recall-time-label">Time:</div>
            <div fxLayout="row" class="label" data-cy="recall-difficulty-label">Difficulty:</div>
          </div>

          <div fxFlex="20" fxLayout="column" class="flex-column" style="align-items: start; display: flex; ">
            <div fxLayout="row" class="entry" *ngIf="finalReport && finalReport.TretmentTime !== null">{{finalReport.TretmentTime}}</div>
            <div fxLayout="row" class="entry" *ngIf="!finalReport || finalReport.TretmentTime === null">No Data</div>
            <div fxLayout="row" class="entry" >No Data</div>
            <!--            <div fxLayout="row" class="entry"  *ngIf="finalReport === null">No Data</div>-->
          </div>

          <div fxFlex="25" fxLayout="column" class="flex-column" style="align-items: end; display: flex; ">
            <div fxLayout="row" class="label">Q Value:</div>
            <div fxLayout="row" class="label">P Value:</div>
          </div>


          <div fxFlex="20" fxLayout="column" class="flex-column" style="align-items: start; display: flex; ">
            <div fxLayout="row" class="entry" *ngIf="finalReport && finalReport.QValue !== null">{{finalReport.QValue}}</div>
            <div fxLayout="row" class="entry" *ngIf="finalReport && finalReport.Pvalue !== null">{{finalReport.Pvalue}}</div>
            <div fxLayout="row" class="entry" *ngIf="!finalReport || finalReport.QValue === null">No Data</div>
            <div fxLayout="row" class="entry" *ngIf="!finalReport || finalReport.Pvalue === null">No Data</div>
          </div>

        </div>
        <div  fxFlex="10" fxLayout="row" *ngIf="finalReport && finalReport.enumCaseRatingID !== null">

          <div fxFlex="40" fxLayout="column" class="flex-column" style="flex: 1; display: flex; padding-right: 2%">
            <div fxLayout="row" class="label">Case Rating:</div>
          </div>

          <div fxFlex="40" fxLayout="column" class="flex-column" style="flex: 1; display: flex" *ngFor="let case of caseRatingEnums | enumDisplay: finalReport.enumCaseRatingID">
            <div fxLayout="row" class="entry">{{case.ItemDisplayValue}}</div>
          </div>

        </div>
        <div  fxFlex="10" fxLayout="row" *ngIf="!finalReport || finalReport.enumCaseRatingID === null">
          <mat-label>No Final Report Data</mat-label>
        </div>
        <div fxLayout="row" style="margin-top: 3%; padding-top: 2%; flex: 1;">

          <div fxLayout="column" class="flex-column" style="flex: 1; display: flex; margin: 2%">
            <div fxLayout="row" class="label-2">M</div>
            <div fxLayout="row" class="entry" *ngIf="!treatment">No Data</div>
            <div fxLayout="row" class="entry" *ngIf="treatment"></div>

          </div>

          <div fxLayout="column" class="flex-column" style="flex: 1; display: flex; margin: 2%">
            <div fxLayout="row" class="label-2">MB</div>
            <div fxLayout="row" class="entry" *ngIf="!treatment">No Data</div>
            <div fxLayout="row" class="entry" *ngIf="treatment"></div>

          </div>

          <div fxLayout="column" class="flex-column" style="flex: 1; display: flex; margin: 2%">
            <div fxLayout="row" class="label-2">D</div>
            <div fxLayout="row" class="entry" *ngIf="!treatment">No Data</div>
            <div fxLayout="row" class="entry" *ngIf="treatment"></div>

          </div>

          <div fxLayout="column" class="flex-column" style="flex: 1; display: flex; margin: 2%">
            <div fxLayout="row" class="label-2">DB</div>
            <div fxLayout="row" class="entry" *ngIf="!treatment">No Data</div>
            <div fxLayout="row" class="entry" *ngIf="treatment"></div>

          </div>

          <div fxFlex="50" fxLayout="column" class="flex-column" style="flex: 1; display: flex; margin: 2%"></div>

        </div>
        <div  fxFlex="50" fxLayout="row">

          <div fxLayout="column" class="flex-column" style="flex: 1; display: flex; margin: 2%">
            <div fxLayout="row" class="label-2">ML</div>
            <div fxLayout="row" class="entry" *ngIf="!treatment">No Data</div>
            <div fxLayout="row" class="entry" *ngIf="treatment"></div>

          </div>

          <div fxLayout="column" class="flex-column" style="flex: 1; display: flex; margin: 2%">
            <div fxLayout="row" class="label-2">L</div>
            <div fxLayout="row" class="entry" *ngIf="!treatment">No Data</div>
            <div fxLayout="row" class="entry" *ngIf="treatment"></div>

          </div>

          <div fxLayout="column" class="flex-column" style="flex: 1; display: flex; margin: 2%">
            <div fxLayout="row" class="label-2">DL</div>
            <div fxLayout="row" class="entry" *ngIf="!treatment">No Data</div>
            <div fxLayout="row" class="entry" *ngIf="treatment"></div>

          </div>

          <div fxLayout="column" class="flex-column" style="flex: 1; display: flex; margin: 2%">
            <div fxLayout="row" class="label-2">D</div>
            <div fxLayout="row" class="entry" *ngIf="!treatment">No Data</div>
            <div fxLayout="row" class="entry" *ngIf="treatment"></div>

          </div>

          <div  fxFlex="50" fxLayout="column" class="flex-column" style="flex: 1; display: flex; margin: 2%">
          </div>

        </div>
      </div>
    </div>
  </div>

  <div fxFlex="75" fxLayout="column" class="flex-column right" data-cy="recall-right-column">
    <div id="tab-nav" data-cy="recall-tab-navigation">

      <div style="flex: 1; overflow: hidden;" data-cy="recall-tabs-container">
        <div style="width: 100%; height: 100%; overflow: hidden; position: relative" data-cy="recall-tabs-wrapper">
          <div style="position: relative; left: 40px" data-cy="recall-tabs-controls">
            <div matTooltip="Remove page" (click)="removeTab($event)"
                 style="position: absolute; right: 95px; color: var(--tdo-secondary); cursor: pointer; margin-top: 12px; user-select: none;"
                 data-cy="recall-remove-tab-button">
              <mat-icon style="position: relative; right: 0;">close</mat-icon>
            </div>

            <div matTooltip="Add new page" (click)="onNewTabClick($event)"
                 style="position: absolute; right: 65px; color: var(--tdo-secondary); cursor: pointer; margin-top: 12px; user-select: none;"
                 data-cy="recall-add-tab-button">
              <mat-icon>add_circle_outline</mat-icon>
            </div>

          </div>


          <mat-tab-group animationDuration="0ms" mat-align-tabs="start" [selectedIndex]="getSelectedIndex()"
                         (selectedTabChange)="onTabChange($event)" data-cy="recall-tab-group">

            <ng-container *ngFor="let tab of recalls, let i = index" (click)="selectTab(i)">

              <mat-tab data-cy="recall-tab">
                <form [formGroup]="selectedRecallForms" *ngIf="!isLoading" formGroupName="selectedRecallForm"
                      style="display: flex; height: 100%; flex-direction: column" data-cy="recall-tab-form">

                <ng-template mat-tab-label>
                  <div class="col" data-cy="recall-tab-label">{{tab?.xauditCreatedOn | date: "short":'PST'}}</div>
                </ng-template>

                  <div fxLayout="column" class="flex-column right" data-cy="recall-tab-content">
                <app-tdo-progress-spinner *ngIf="isLoading" data-cy="recall-loading-spinner"></app-tdo-progress-spinner>

                    <div fxFlex="5" fxLayout="row" class="" data-cy="recall-form-row">
                      <div fxFlex="20" fxLayout="column" class="flex-column" style="flex: 1; justify-content: center" data-cy="recall-form-column">
                        <span *ngIf="autoFills.length > 1">
                          Autofill: <button style="display: inline-flex" class="autofill" *ngFor="let auto of autoFills" [value]="auto.AutofillID"
                        (click)="applyAutoFill(auto.AutofillID, tab)">
                          {{auto.AutofillName}}
                            </button> <button class="autofill" (click)="saveAutofill(tab)">Save Autofill</button>
                        </span>
                        <span *ngIf="autoFills.length < 1">No Auto Fills Saved</span>
                      </div>
                      <div fxLayout="column" class="flex-column" style=" flex: 1">

                      </div>
                      <div  fxLayout="column" class="flex-column" style=" flex: 1">
<!--                        <mat-select [(ngModel)]="selectedRecallType" label="This Recall:" *ngIf="docTags.length > 1">-->
<!--                          <mat-option *ngFor="let tag of docTags" [value]="tag.ValidValueItemId">-->
<!--                            {{tag.ItemDisplayValue}}-->
<!--                          </mat-option>-->
<!--                        </mat-select>-->
                      </div>
                      <div  fxLayout="column" class="flex-column" style=" flex: 1">

                      </div>
                      <div fxFlex="35" fxLayout="column" class="flex-column" style="flex: 1; justify-content: center">
                        <mat-label>Images for this recall:</mat-label>
                      </div>
                    </div>

                    <div fxLayout="row" style="flex: 1; max-height: 60%">
                      <div fxFlex="65" fxLayout="column" class="flex-column rightDiv">
                        <div fxFlex="65" fxLayout="row">
                          <div fxFlex="35" fxLayout="column" style="display: flex; justify-content: center; height: 100%">

                            <div fxLayout="row" style="flex: 1;" class="label">
                              Has this tooth been restored?
                            </div>

                            <div fxLayout="row" style="flex: 1;" class="label">
                              Coronal Leakage?
                            </div>

                            <div fxLayout="row" style="flex: 1;" class="label">
                              Asymptomatic and functional?
                            </div>

                            <div fxLayout="row" style="flex: 1 0 0; display: flex" class="label">
                              Has lucency decreased in size?
                            </div>

                            <div fxLayout="row" style="flex: 1 0 0; display: flex" class="label">
                              Is PDL normal?
                            </div>

                            <div fxLayout="row" style="flex: 1 0 0; display: flex" class="label">
                              Palpation soreness:
                            </div>

                            <div fxLayout="row" style="flex: 1 0 0; display: flex" class="label">
                              Percussion tests:
                            </div>

                            <div fxLayout="row" style="flex: 1 0 0; display: flex" class="label">
                              Mobility:
                            </div>

                            <div fxLayout="row" style="flex: 1 0 0; display: flex" class="label">
                              Sinus tract present?
                            </div>

                          </div>
                          <div fxFlex="60" fxLayout="column" >


                              <div fxLayout="row" style="flex: 1; justify-content: start" class="entry-2" >
                                <span *ngFor="let item of restoredValues" style="flex: 1; max-width: 25%; display: flex;">
                                  <input type="radio" [formControlName]="'restored' + i"  name="restored" [value]="item.ValidValueItemId"
                                         [(ngModel)]="tab.enumEndoRecallToothResoredID" (change)="onRestoredChange(item, tab)"
                                         [checked]="tab.enumEndoRecallToothResoredID == item.ValidValueItemId">
                                  {{item.ItemDisplayValue}}
                                </span>
                              </div>
                              <div fxLayout="row" style="flex: 1; justify-content: start" class="entry-2">
                                <span *ngFor="let item of coronalValues"  style="flex: 1; display: flex; max-width: 25%">
                                  <input type="radio" formControlName="coronal"  name="coronal" [value]="item.ValidValueItemId"
                                         [(ngModel)]="tab.enumEndoRecallCoronalLeakID" (change)="onCoronalChange(item, tab)"
                                         [checked]="tab.enumEndoRecallCoronalLeakID == item.ValidValueItemId">
                                  {{item.ItemDisplayValue}}
                                </span>
                              </div>
                              <div fxLayout="row" style="flex: 1; justify-content: start" class="entry-2">
                                <span *ngFor="let item of asymValues"  style="flex: 1; display: flex; max-width: 25%">
                                  <input type="radio" formControlName="asym"  name="asym" [value]="item.ValidValueItemId"
                                         [(ngModel)]="tab.enumEndoRecallAsymFuncID" (change)="onAsymChange(item, tab)"
                                         [checked]="tab.enumEndoRecallAsymFuncID == item.ValidValueItemId">
                                  {{item.ItemDisplayValue}}
                                </span>
                              </div>
                              <div fxLayout="row" style="flex: 1; justify-content: start" class="entry-2">
                                <span *ngFor="let item of lucencyValues"  style="flex: 1; display: flex; max-width: 25%">
                                  <input type="radio" formControlName="lucency"  name="lucency" [value]="item.ValidValueItemId"
                                         [(ngModel)]="tab.enumEndoRecallLucencyID" (change)="onLucencyChange(item, tab)"
                                         [checked]="tab.enumEndoRecallLucencyID == item.ValidValueItemId">
                                  {{item.ItemDisplayValue}}
                                </span>
                              </div>
                              <div fxLayout="row" style="flex: 1; justify-content: start" class="entry-2">
                                <span *ngFor="let item of pdlidValues"  style="flex: 1; display: flex; max-width: 25%">
                                  <input type="radio" formControlName="pdl"  name="pdl" [value]="item.ValidValueItemId"
                                         [(ngModel)]="tab.enumEndoRecallPDLID" (change)="onPDLChange(item, tab)"
                                         [checked]="tab.enumEndoRecallPDLID == item.ValidValueItemId">
                                  {{item.ItemDisplayValue}}
                                </span>
                              </div>
                              <div fxLayout="row" style="flex: 1; justify-content: start" class="entry-2">
                                <span *ngFor="let item of palpValues"  style="flex: 1; display: flex; max-width: 25%">
                                  <input type="radio" formControlName="palp"  name="palp" [value]="item.ValidValueItemId"
                                         [(ngModel)]="tab.enumEndoRecallPalpSoreID" (change)="onPalpChange(item, tab)"
                                         [checked]="tab.enumEndoRecallPalpSoreID == item.ValidValueItemId">
                                  {{item.ItemDisplayValue}}
                                </span>
                              </div>
                              <div fxLayout="row" style="flex: 1; justify-content: start" class="entry-2">
                                <span *ngFor="let item of percussValues"  style="flex: 1; display: flex; max-width: 25%">
                                  <input type="radio" formControlName="percuss" name="percuss" [value]="item.ValidValueItemId"
                                         [(ngModel)]="tab.enumEndoRecallPercussID" (change)="onPercussChange(item, tab)"
                                         [checked]="tab.enumEndoRecallPercussID == item.ValidValueItemId">
                                  {{item.ItemDisplayValue}}
                                </span>
                              </div>
                              <div fxLayout="row" style="flex: 1; justify-content: start" class="entry-2">
                                <span *ngFor="let item of mobilityValues"  style="flex: 1; display: flex; max-width: 25%">
                                  <input type="radio" formControlName="mobility" name="mobility" [value]="item.ValidValueItemId"
                                         [(ngModel)]="tab.enumEndoRecallMobilityID" (change)="onMobilityChange(item, tab)"
                                         [checked]="tab.enumEndoRecallMobilityID == item.ValidValueItemId">
                                  {{item.ItemDisplayValue}}
                                </span>
                              </div>
                              <div fxLayout="row" style="flex: 1; justify-content: start" class="entry-2">
                                <span *ngFor="let item of sinusValues"  style="flex: 1; display: flex; max-width: 25%">
                                  <input type="radio" formControlName="sinus" name="sinus" [value]="item.ValidValueItemId"
                                         [(ngModel)]="tab.enumEndoRecallSinusTrackID" (change)="onSinusChange(item, tab)"
                                         [checked]="tab.enumEndoRecallSinusTrackID == item.ValidValueItemId">
                                  {{item.ItemDisplayValue}}
                                </span>
                              </div>

                          </div>
                        </div>
                          <div fxFlex="30" fxLayout="row" style="margin-top: 3%">
                            <div fxLayout="column" class="flex-column" style="flex: 1; display: flex">
                            </div>
                            <div fxFlex="10" fxLayout="column" class="flex-column" style="flex: 1; display: flex">
                              <mat-label>Probings:</mat-label>
                            </div>
                            <div fxFlex="10" fxLayout="column" class="flex-column" style="align-items: end; display: flex; justify-content: center ">

                              <div fxLayout="row" class="label">M:</div>
                              <div fxLayout="row" class="label">MB:</div>
                              <div fxLayout="row" class="label">B:</div>
                              <div fxLayout="row" class="label">DB:</div>
                            </div>
                            <div fxFlex="10" fxLayout="column" class="flex-column" style="align-items: start; display: flex; ">
                              <div fxLayout="row" class="entry">
                                <mat-select [(value)]="tab.probingM_enumProbingDepthID"
                                            [formControlName]="'probingM_enumProbingDepthID' + i " [compareWith]="compareFn">
                                  <mat-option *ngFor="let val of probingValues" [value]="val.ValidValueItemId">{{val.ItemDisplayValue}}</mat-option>
                                </mat-select>
                              </div>
                              <div fxLayout="row" class="entry">
                                <mat-select [(value)]="tab.probingMB_enumProbingDepthID"
                                            formControlName="probingMB_enumProbingDepthID" [compareWith]="compareFn">
                                  <mat-option *ngFor="let val of probingValues" [value]="val.ValidValueItemId">{{val.ItemDisplayValue}}</mat-option>
                                </mat-select>

                              </div>
                              <div fxLayout="row" class="entry">

                                <mat-select [(value)]="tab.probingB_enumProbingDepthID"
                                            formControlName="probingB_enumProbingDepthID" [compareWith]="compareFn">
                                  <mat-option *ngFor="let val of probingValues" [value]="val.ValidValueItemId">{{val.ItemDisplayValue}}</mat-option>
                                </mat-select>

                              </div>
                              <div fxLayout="row" class="entry">
                                <mat-select [(value)]="tab.probingDB_enumProbingDepthID"
                                            formControlName="probingDB_enumProbingDepthID" [compareWith]="compareFn">
                                  <mat-option name="probingDB_enumProbingDepthID" *ngFor="let val of probingValues" [value]="val.ValidValueItemId">{{val.ItemDisplayValue}}</mat-option>
                                </mat-select>
                              </div>
                            </div>
                            <div fxFlex="10" fxLayout="column" class="flex-column" style="align-items: end; display: flex; justify-content: center ">
                              <div fxLayout="row" class="label">ML:</div>
                              <div fxLayout="row" class="label">L:</div>
                              <div fxLayout="row" class="label">DL:</div>
                              <div fxLayout="row" class="label">D:</div>
                            </div>
                            <div fxFlex="10" fxLayout="column" class="flex-column" style="align-items: start; display: flex; ">
                              <div fxLayout="row" class="entry">

                                <mat-select [(value)]="tab.probingML_enumProbingDepthID"
                                            formControlName="probingML_enumProbingDepthID" [compareWith]="compareFn">
                                  <mat-option *ngFor="let val of probingValues" [value]="val.ValidValueItemId">{{val.ItemDisplayValue}}</mat-option>
                                </mat-select>

                              </div>
                              <div fxLayout="row" class="entry">

                                <mat-select [(value)]="tab.probingL_enumProbingDepthID"
                                            formControlName="probingL_enumProbingDepthID" [compareWith]="compareFn">
                                  <mat-option *ngFor="let val of probingValues" [value]="val.ValidValueItemId">{{val.ItemDisplayValue}}</mat-option>
                                </mat-select>

                              </div>
                              <div fxLayout="row" class="entry">

                                <mat-select [(value)]="tab.probingDL_enumProbingDepthID"
                                            [formControlName]="'probingDL_enumProbingDepthID' + i" [compareWith]="compareFn">
                                  <mat-option *ngFor="let val of probingValues" [value]="val.ValidValueItemId">{{val.ItemDisplayValue}}</mat-option>
                                </mat-select>

                              </div>
                              <div fxLayout="row" class="entry">

                                <mat-select [(value)]="tab.probingD_enumProbingDepthID"
                                            formControlName="probingD_enumProbingDepthID" [compareWith]="compareFn">
                                  <mat-option *ngFor="let val of probingValues" [value]="val.ValidValueItemId">{{val.ItemDisplayValue}}</mat-option>
                                </mat-select>

                              </div>
                            </div>
                            <div fxLayout="column" class="flex-column" style="align-items: start; display: flex; flex: 1 0 0">
                            </div>
                          </div>
                          <div fxFlex="10" fxLayout="row">
                            <div fxLayout="column" class="flex-column" style="flex: 1; display: flex">
                            </div>
                            <div fxFlex="20" fxLayout="column" class="flex-column"
                                 style="flex: 1; display: flex; padding-right: 2%; justify-content: center; align-items: center">
                              <div fxLayout="row" class="label">Current Finding:</div>
                            </div>
                            <div fxFlex="30" fxLayout="column" class="flex-column" style="flex: 1; display: flex; margin-right: 0.5%">
                              <div fxLayout="row" class="entry">
                                <mat-select [(ngModel)]="tab.enumEndoRecallCurrentFindingID" [compareWith]="compareFn"
                                            formControlName="enumEndoRecallCurrentFindingID">
                                  <mat-option *ngFor="let val of findingValues" [value]="val?.ValidValueItemId">{{val?.ItemDisplayValue}}</mat-option>
                                </mat-select>
                              </div>
                            </div>
                            <div fxLayout="column" class="flex-column" style="flex: 1; display: flex">
                            </div>
                          </div>
                      </div>

                      <div fxFlex="35" class="flex-column rightDiv">
                        <div fxLayout="row" *ngIf="thumbnailImages.length < 1"
                             style="justify-content: center; align-items: center; background-color: var(--tdo-background); border: 5px solid white; min-height: 300px">
                          No Images
                        </div>
                        <div fxLayout="row" *ngIf="thumbnailImages.length > 1"
                             style="justify-content: center; align-items: center; background-color: var(--tdo-background); border: 5px solid white">
                          <img [alt]="'Image' + i" *ngFor="let image of thumbnailImages, let i = index" [src]="image.imageSource"/>
                        </div>
                        <div fxLayout="row" style="justify-content: flex-start">
                          <img class="arrow-icons" alt="previous" src="https://img.icons8.com/material/100/000000/back--v1.png"/>
                          <img class="image-icons" alt="open current image in draw" src="assets/icons/draw.svg"/>
                          <img class="image-icons" alt="open all images in Studio" src="assets/icons/icons8-photo-gallery.svg"/>
                          <img class="arrow-icons" alt="next" src="https://img.icons8.com/material/100/000000/forward--v1.png"/>
                        </div>

                        <div  fxLayout="row" style="justify-content: center">
                          <img class="camera-icons" (click)="openDrawInNewWindow()" alt="Open Imaging"  src="assets/Images/imaging/top-menu/camera.svg"/>
<!--                          <img class="camera-icons" (click)="openAcquireInNewWindow()" alt="Open Acquire"  src="assets/Images/imaging/top-menu/switch-camera.svg"/>-->
                        </div>

                        <div fxLayout="row" style="justify-content: center">
                          <div fxFlex="50" fxLayout="column" style="align-items: flex-start; justify-content: center">
                            <div fxFlex="50" fxLayout="row"><mat-checkbox [checked]="sendRecallNow" (change)="isSendRecall(tab)">Send Recall Report</mat-checkbox></div>
                            <div fxFlex="50" fxLayout="row">Date Sent</div>
                          </div>
                          <div fxFlex="50" fxLayout="column" style="align-items: flex-end; justify-content: center">
                            <div fxFlex="50" fxLayout="row">
                              <button [disabled]="!sendRecallNow" class="tdo-btn primary-accent" (click)="sendRecall(tab)">
                                Send Now
                              </button>
                            </div>
                            <div fxFlex="50" fxLayout="row">
                              <span *ngIf="tab.RecallReportSentOn" style="background-color: var(--tdo-background); min-width: 120px; max-height: 40px; text-align: center; align-items: center">
                                {{tab.RecallReportSentOn | date: 'MM/dd/YYYY'}}
                              </span>
                              <span *ngIf="!tab.RecallReportSentOn" style="background-color: var(--tdo-background); min-width: 120px; max-height: 40px; text-align: center; align-items: center">

                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                    <div fxFlex="12" fxLayout="row" class="rightDiv">
                      <div fxLayout="column" style="width: 100%">
                        <div fxFlex="33" fxLayout="row" style="align-items: center; justify-content: center">
                          <img alt="convert to note" src="https://img.icons8.com/external-bearicons-blue-bearicons/64/000000/external-notes-graphic-design-bearicons-blue-bearicons.png"
                          class="save-icon" (click)="sendToNote(tab)"/>
                          <img (click)="printPDF()" alt="print" src="https://img.icons8.com/ultraviolet/40/000000/print.png"/>
                        </div>
<!--                        <div fxLayout="row" style="flex: 1">-->
<!--                        </div>-->
                        <div fxFlex="66" fxLayout="row" style="align-items: center">
                          <div fxLayout="column" style="flex: 1 0 0; justify-content: center">
                            <span style="text-align: end; display: inline; flex:1; margin: 0.75%">
                              <mat-label>Next Recall: </mat-label>
                              <mat-select style="max-width: 50%">
                                <mat-option *ngFor="let opt of nextRecallOpts" [value]="opt.ValidValueItemId" (change)="selectNextRecall(opt)">
                                  {{opt.ItemDisplayValue}}
                                </mat-option>
                                <mat-option *ngIf="!finalReport">No Data</mat-option>
                              </mat-select>
                            </span>
                          </div>
                          <div fxLayout="column" style="flex: 1 0 0; justify-content: center">
                            <span style="text-align: end; display: inline; flex:1; margin: 0.75%">
                              <mat-label>On or Around Date: </mat-label>
                              <mat-select style="max-width: 50%">
                                <mat-option *ngIf="finalReport">
                                  {{finalReport.RecallDate}}
                                </mat-option>
                                <mat-option *ngIf="!finalReport">No Data</mat-option>
                              </mat-select>
                            </span>
                          </div>
                          <div fxLayout="column" style="flex: 1 0 0; justify-content: center; margin: 0.75%">
                            <mat-checkbox class="entry-2" disabled *ngIf="!finalReport">Super Recall</mat-checkbox>
                            <mat-checkbox class="entry-2" *ngIf="finalReport" [checked]="finalReport.isSuperRecall === true" (change)="superRecall()">Super Recall</mat-checkbox>
                          </div>
                          <div fxFlex="15" fxLayout="column" style="justify-content: flex-end">
                            <button class="tdo-button tdo-save" style="min-width: 120px; margin: 0.75%"
                                    (click)="onSubmit()">Save
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </mat-tab>
            </ng-container>
          </mat-tab-group>
        </div>
      </div>
    </div>
  </div>
</div>
